// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import styled from 'styled-components';

export const NAVIGATION_TOP_OFFSET = -100;

const S = {
  NavigationContainer: styled.ul`
    display: flex;
    flex-wrap: wrap;
    margin-top: 5px;
    justify-content: flex-start;
  `,
  NavigationTitle: styled.li<{ isComplete: boolean, isRemark: boolean}>`
    color: #434343;
    cursor: pointer;
    display: flex;
    font-weight: 400;
    font-size: 22px;
    width: 39px;
    height: 39px;
    justify-content: center;
    align-items: center;
    margin: 5px 3px 23px 3px;
    margin-bottom: 18px;
    color: #8D8D8D;
    border-radius: 50%;
    ${props => (props.isComplete) ? 'background: #EF82003D;' : null};
    ${props => (props.isRemark) ? 'border: 2px solid #EF8200;' : null};
  `,
  NavigationHighLight: styled.div<{ isFocus: boolean }>`
  ${props => (props.isFocus) ? 'text-decoration: underline;' : null};
  `
}

const NavigationContent = (props: any): JSX.Element => {
  const item = props.item;
  const setExamNowFocus = props.setExamNowFocus;
  const isFocus = props.isFocus;
  const setExamClickToRender = props.setExamClickToRender;
  const setExamFocusType = props.setExamFocusType;
  const navigationType = props.navigationType;
  const isComplete = item.isComplete;
  const isRemark = item.isRemark;

  const handleNavigate = (item: any) => {
    setExamNowFocus(item.title);
    localStorage.setItem('examLastFocus', item.title);
    setExamClickToRender(item);
    setExamFocusType(navigationType)
    localStorage.setItem('examFocusType', navigationType);
  }

  return (
    <>
      <S.NavigationTitle isComplete={isComplete} isRemark={isRemark} onClick={() => handleNavigate(item)}>
        <S.NavigationHighLight isFocus={isFocus}>
          {parseInt(item.title)+1}
        </S.NavigationHighLight>
      </S.NavigationTitle>
    </>
  )
}

const Navigation = (props: any): JSX.Element => {
  const focusItem = props.examNowFocus;
  const setExamNowFocus = props.setExamNowFocus;
  const navigationType = props.navigationType;
  const examFocusType = props.examFocusType;
  const setExamFocusType = props.setExamFocusType;
  const examList = props.examList;
  const setExamClickToRender = props.setExamClickToRender;

  const NavigationContents = examList.map((item: any, index: number) => {
    if (navigationType === examFocusType) {
      switch (item.title) {
        case focusItem:
          return (<NavigationContent key={index} setExamFocusType={setExamFocusType} navigationType={navigationType} isFocus={true} isComplete={item.isComplete} item={item} setExamNowFocus={setExamNowFocus} setExamClickToRender={setExamClickToRender} ></NavigationContent>);
        case 'Overview':
          return (<div key={index}></div>);
        default:
          return (<NavigationContent key={index} isFocus={false} setExamFocusType={setExamFocusType} navigationType={navigationType} isComplete={item.isComplete} item={item} setExamNowFocus={setExamNowFocus} setExamClickToRender={setExamClickToRender} ></NavigationContent>);
      }
    } else {
      return (<NavigationContent key={index} setExamFocusType={setExamFocusType} navigationType={navigationType} isFocus={false} isComplete={item.isComplete} item={item} setExamNowFocus={setExamNowFocus} setExamClickToRender={setExamClickToRender} ></NavigationContent>);
    }
  })
  return (
    <S.NavigationContainer>
      {NavigationContents}
    </S.NavigationContainer>
  )
}

export default Navigation;
